/* TPW native scroll-snap rail (M7, founder 2026-06-27) — replaces the Swiper
   library on the featured-collection slider. Zero library: the slides keep the
   theme's own :not(.swiper-initialized) responsive widths, the wrapper is a
   native CSS scroll-snap rail (see section-featured-collection.css), and the
   arrows just scroll it. Faster (no Swiper instance), our own feel. */
(function () {
  function railOf(section) {
    // the slider element IS the scroll container (the inner flex wrapper won't
    // scroll reliably); slides live inside it either way.
    return section.querySelector(".js-swiper-featured-collection");
  }

  function initSlider(section) {
    var rail = railOf(section);
    if (!rail || rail.__tpwRail) return;
    rail.__tpwRail = true;

    var prevBtn = section.querySelector(".swiper-button-prev");
    var nextBtn = section.querySelector(".swiper-button-next");

    function step() {
      var card = rail.querySelector(".swiper-slide");
      var w = card ? card.getBoundingClientRect().width + 8 : rail.clientWidth * 0.8;
      return w * 2; // advance ~2 cards per arrow press
    }
    function go(dir) { rail.scrollBy({ left: dir * step(), behavior: "smooth" }); }
    if (prevBtn) prevBtn.addEventListener("click", function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { go(1); });

    // disable the arrows at the ends (mirrors Swiper's .swiper-button-disabled)
    function updateArrows() {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      var atStart = rail.scrollLeft <= 1;
      var atEnd = rail.scrollLeft >= max;
      if (prevBtn) { prevBtn.disabled = atStart; prevBtn.classList.toggle("swiper-button-disabled", atStart); }
      if (nextBtn) { nextBtn.disabled = atEnd; nextBtn.classList.toggle("swiper-button-disabled", atEnd); }
    }
    rail.addEventListener("scroll", updateArrows, { passive: true });
    window.addEventListener("resize", updateArrows);
    updateArrows();
  }

  function initSection(section) {
    if (section && section.classList && section.classList.contains("featured-collection-section")) {
      initSlider(section);
    }
  }
  function initAll() {
    document.querySelectorAll(".featured-collection-section").forEach(initSlider);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", function (e) { initSection(e.target); });
})();
